.wrapper {
  display: flex;
  flex: 1;
  padding: 1.5rem 1.5rem 0 1.5rem;
  width: 100%;
}

.footer {
  min-height: 50vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 2;
  position: relative;
  background-color: white;
  width: inherit;
  border-radius: 14px;
  margin-bottom: 36px;
}

.cards-container {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: 1fr 1fr;
  gap: 36px 36px;
}

.content {
  min-height: 423px;
  background: white;
  padding: 72px;
  padding-bottom: 36px;
  display: grid;
  row-gap: 36px;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: auto auto auto auto;
  grid-template-areas:
    'title empty'
    'links empty'
    'label empty'
    'logo contact';
  width: inherit;
  border-radius: 8px;
}

@media screen and (max-width: 58em) {
  footer .content {
    margin-top: 6vw;
    grid-template-columns: 1fr;
    grid-template-rows: auto;
    grid-template-areas:
      'title'
      'label'
      'contact'
      'logo';
    padding: 6vw;
  }
}

footer .title {
  background-image: linear-gradient(47deg, #ff6494, #ff7a7a);
  background-size: cover;
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  text-fill-color: transparent;
  color: #f979ae;
  display: inline;
  font-family: Syne, Georgia, serif;
  font-size: clamp(20px, calc(20px + 2vw), 32px);
  grid-area: headline;
  margin-top: 0;
  margin-bottom: 36px;
  max-width: 432px;
  grid-area: title;
  line-height: 1.1;
}

footer .footer-top {
  width: 100%;
  margin-bottom: 6vw;
  padding: 6vw;
}

footer .footer-top &__heading {
  margin-bottom: 72px;
}

.cards-container {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: 1fr 1fr;
  gap: 36px 36px;
  width: inherit;
}

footer .logoContainer {
  grid-area: logo;
  display: flex;
  align-items: center;
  grid-area: logo;
  align-self: end;
}

footer .logoContainer img {
  margin-right: 36px;
}

footer .logoContainer span {
  font-size: 14px;
  font-family: Aeroport, Helvetica, sans-serif;
  opacity: 0.6;
}

footer .linksContainer {
  grid-area: links;
  display: flex;
}

.link {
  font-family: Aeroport;
  font-size: 0.9rem;
  color: var(--text-dark);
}

.link:hover {
  color: var(--text-dark) !important;
}

footer .labelContainer {
  grid-area: label;
  grid-column: 1 / span 2;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}

footer .labelItem {
  display: flex;
  align-items: center;
  justify-content: left;
  min-width: 100%;
  margin-bottom: 18px;
}

@media screen and (min-width: 600px) {
  footer .labelItem {
    min-width: 50%;
  }
}

@media screen and (min-width: 900px) {
  footer .labelItem {
    min-width: 33%;
  }
}

footer .labelIcon {
  margin-right: 18px;
  max-width: 36px;
}

footer .labelDescription {
  font-size: 11px;
  font-family: Aeroport, Helvetica, sans-serif;
  opacity: 0.6;
}

footer .navContainer {
  grid-area: contact;
  display: flex;
  width: 100%;
  align-items: flex-end;
  justify-content: flex-end;
}

footer .nav p {
  font-size: 14px;
  font-family: Aeroport, Helvetica, sans-serif;
}

footer .nav p a {
  color: #4a4a4a;
}

footer .navContainer p {
  margin: 0;
  padding: 0;
}

footer address {
  margin-right: 72px;
}

footer address p,
footer li a,
footer p a {
  font-family: Aeroport, Helvetica, sans-serif;
  font-size: 12px;
  font-style: normal;
  margin: 0;
  line-height: 1.5;
}

.container.fullbleed {
  padding: 0;
}

@media screen and (max-width: 58em) {
  .container {
    padding: 0;
  }
  .footer-top {
    padding: 0;
  }
  .footer-top &__heading {
    margin: calc(72px * 12vw);
  }

  .cards-container {
    grid-template-columns: 1fr 1fr;
    grid-template-rows: auto;
    grid-gap: 18px;
  }

  .cards-container a:last-of-type {
    grid-column: span 2;
    width: 100%;
  }
}
